import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const VISIT_TYPE_OPTIONS = [
  { value: 'selection_visit', label: 'Selection Visit' },
  { value: 'siv', label: 'SIV' },
  { value: 'screening', label: 'Screening' },
  { value: 'baseline', label: 'Baseline' },
  { value: 'visit_number', label: 'Visit Number' },
  { value: 'imv', label: 'IMV' },
  { value: 'cov', label: 'COV' },
];
const STATUS_OPTIONS = [
  { value: 'ongoing', label: 'Ongoing' },
  { value: 'complete', label: 'Complete' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const VisitFilters = ({ filters, setFilters, sites, studies }) => (
  <Card className="border-0 shadow-lg" data-testid="visit-filters">
    <CardHeader><CardTitle>Filters</CardTitle></CardHeader>
    <CardContent>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <div>
          <Label htmlFor="site-filter">Site</Label>
          <Select value={filters.site_id} onValueChange={(value) => setFilters({ ...filters, site_id: value })}>
            <SelectTrigger><SelectValue placeholder="All Sites" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Sites</SelectItem>
              {sites.map(s => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="study-filter">Study</Label>
          <Select value={filters.study_id} onValueChange={(value) => setFilters({ ...filters, study_id: value })}>
            <SelectTrigger><SelectValue placeholder="All Studies" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Studies</SelectItem>
              {studies.map(s => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="visit-type-filter">Visit Type</Label>
          <Select value={filters.visit_type} onValueChange={(value) => setFilters({ ...filters, visit_type: value })}>
            <SelectTrigger><SelectValue placeholder="All Types" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Types</SelectItem>
              {VISIT_TYPE_OPTIONS.map(opt => <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="status-filter">Status</Label>
          <Select value={filters.status} onValueChange={(value) => setFilters({ ...filters, status: value })}>
            <SelectTrigger><SelectValue placeholder="All Status" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Status</SelectItem>
              {STATUS_OPTIONS.map(opt => <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="pi-filter">PI Name</Label>
          <Input placeholder="Search PI name..." value={filters.pi_name} onChange={(e) => setFilters({ ...filters, pi_name: e.target.value })} />
        </div>
      </div>
    </CardContent>
  </Card>
);
